import { classes, media, style } from "typestyle";
import colors from "../../styles/colors";
import fontSize from "../../styles/fontSize";
import mediaQueries, { upTo } from "../../styles/mediaQueries";
import { mb6, ml4, mr4 } from "../../styles/spacing";

export const container = style({
  overflow: "hidden",
});

export const footer = classes(
  fontSize.sm,
  style(
    ml4,
    mr4,
    {
      textAlign: "center",
      color: colors.grey[700],
      height: "fit-content",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    media(upTo(mediaQueries.tablet), mb6),
  ),
);

export const promoButton = classes(
  style({
    backgroundColor: `${colors.grey[100]} !important`,
    fontWeight: 500,
    width: "fit-content",
    padding: "0.5rem 0.75rem !important",
    minHeight: "36px !important",
  }),
  fontSize.sm,
);
